var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav navbar-nav navbar-right navbar-right-no-collapse"},[_vm._l((_vm.actions),function(comp){return _c('app-header-action',{key:comp.cid},[_c(comp,{tag:"component"})],1)}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }